import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogButtonStyle, DialogConfig, DialogOption } from './modules/shared/ui/dialog/dialog-options';
import { DialogComponent } from './modules/shared/ui/dialog/dialog.component';

import { HistoryService } from './services/history/history.service';
import { UserSettingsService } from './services/user-settings/user-settings.service';
import { AppUpdateService } from './services/app-update/app-update.service';
import { DeviceAuthService } from './services/device-auth/device-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  static snackBar: MatSnackBar;
  static dialog: MatDialog;

  title = 'InfraRed 2.2.0';

  constructor( historyService: HistoryService,
               private userSettingsService: UserSettingsService,
               // Injected so update monitoring (periodic checks, restart prompt)
               // starts with the app.
               private appUpdateService: AppUpdateService,
               // Injected so the device-PIN idle lock is armed with the app.
               private deviceAuthService: DeviceAuthService,
               private sb: MatSnackBar,
               private dg: MatDialog ) {
    historyService.loadRouting();
    AppComponent.snackBar = sb;
    AppComponent.dialog = dg;
  }

  public static showSnack( message: string, actionLabel: string, durationMs: number = null ) {
    if ( durationMs ) {
      return AppComponent.snackBar.open( message, actionLabel, { duration: durationMs } );
    } else {
      return AppComponent.snackBar.open( message, actionLabel );
    }
  }

  public static showMessage( title: string, message: string, options: string [],
                             showClose: boolean = true, width: string = '500px', height: string = '300px', ) {
    const dialogOptions = new DialogConfig();
    dialogOptions.showClose = showClose;
    dialogOptions.title = title;
    dialogOptions.message = message;
    dialogOptions.width = width;
    dialogOptions.height = height;
    if ( !options ) {
      options = [ 'OK' ];
    }
    options.forEach( (o) => {
      let style = DialogButtonStyle.Normal;
      if ( Array.from( ['yes', 'confirm', 'save' ]).indexOf(o.toLowerCase()) !== -1 ) {
        style = DialogButtonStyle.Confirm;
      } else if ( Array.from( ['no', 'cancel', 'delete' ]).indexOf(o.toLowerCase()) !== -1) {
        style = DialogButtonStyle.Cancel;
      }
      dialogOptions.options.push( new DialogOption( o, o, style));
    });
    return this.showDialog(dialogOptions);
  }

  public static showDialog( dialogConfig: DialogConfig ): MatDialogRef<DialogComponent> {
    const matConfig: MatDialogConfig = {
      height: dialogConfig.height,
      width: dialogConfig.width,
      data: dialogConfig,
    };
    // Only pass autoFocus when set: an explicit undefined would override
    // Material's default rather than fall back to it.
    if (dialogConfig.autoFocus !== undefined) {
      matConfig.autoFocus = dialogConfig.autoFocus;
    }
    if (dialogConfig.dismissOnBackdrop) {
      matConfig.disableClose = false;
    }
    return AppComponent.dialog.open( DialogComponent, matConfig);
  }
}
